
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import GalleryItem from "../common/GalleryItem";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { IGallery } from "../../../../../services";

export interface GalleryPreviewProps {
    basePath: string;
    gallery: IGallery[];
}

function GalleryPreview({ basePath, gallery }: GalleryPreviewProps) {

    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!gallery.length) return null;

    return (<section className={Classname.build(styles["section"], styles["bg-ink"])}>
        <div className={styles["container"]}>
            <SectionHeader kicker={labels.gallery_kicker} title={labels.gallery_title} titleEm={labels.gallery_title_em}
                action={<ReactRouterDom.NavLink end className={styles["link-more"]} to={{ pathname: pagePath(basePath, "GALLERY"), search: searchParams.toString() }}>{i18nManager.Labels.view_all}</ReactRouterDom.NavLink>} />
            <div className={styles["masonry"]}>
                {gallery.map((g) => (<GalleryItem key={g.external_id} gallery={g} />))}
            </div>
        </div>
    </section>);
}

export default GalleryPreview;
